<template>
  <!-- Map 上の Popup -->
  <div class="popup popup-shadow">
    <div class="popup-container">
      <div class="icon-close float-right" v-on:click="onClickClose">
        &#10006;
      </div>
      <slot name="header">
        <h5 class="header" v-html="header" />
      </slot>
      <hr class="hr" />
      <slot name="body">
        <div class="body" v-html="body" />
      </slot>
      <slot name="footer">
        <footer class="footer" v-html="footer" />
      </slot>
    </div>
    <!-- 下部 Pop (mapbox popup 風) -->
    <div class="popup-tip"></div>
  </div>
</template>

<script>
/**
 * Map 上の Popup コンテンツデザインベース
 * マップ(画面)上の位置は、parent で制御する
 */
export default {
  name: 'AppMapPopup',
  props: {
    header: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: null,
    },
    footer: {
      type: String,
      default: null,
    },
    left: {
      type: Number,
      default: 0,
    },
    top: {
      type: Number,
      default: 0,
    },
  },
  mounted: function () {
    this.resizeObserver = new ResizeObserver(this.$_onResize)
    this.resizeObserver.observe(this.$el)
  },
  beforeDestroy: function () {
    this.resizeObserver && this.resizeObserver.disconnect()
  },
  methods: {
    /**
     * リサイズ
     */
    $_onResize: function () {
      /**
       * リサイズイベント
       * @param {Object} clientRect
       */
      this.$emit('resize', this.$el.getBoundingClientRect())
    },
    /**
     * 閉じるボタンが押された
     */
    onClickClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-shadow {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.24));
}

.popup {
  text-align: left;
  font-size: 0.875rem;
  background-color: #fff;
  border-radius: 8px;
  padding: 12px;

  h5 {
    font-size: 0.75rem;
    font-weight: 700;
    margin-left: 4px;
    padding-right: 16px;
  }

  hr {
    margin: 4px 0;
    border-top: 1px solid #333;
  }

  footer {
    text-align: right;
    color: #242;
  }
  footer span {
    cursor: pointer;
  }

  .popup-tip {
    margin: auto;
    position: absolute;
    bottom: -9px;
    left: 0;
    right: 0;
    z-index: 1;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom: none;
    border-top-color: #fff;
    display: block;
    align-self: center;
  }
}

.icon-close {
  cursor: pointer;
  margin: -4px 0;
}
</style>
